var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHighFivePana = function SvgHighFivePana(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 430",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 314.6,
    y: 141.62,
    width: 50.15,
    height: 72.69,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.09,
    y: 141.62,
    width: 50.15,
    height: 72.69,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.32,
    y: 149.49,
    width: 37.69,
    height: 56.95,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,206.43s0-.09,0-.27v-.81c0-.72,0-1.76,0-3.12,0-2.73,0-6.71,0-11.74,0-10,0-24.26-.06-41l.12.12-37.68,0h0l.14-.14c0,21.48,0,41.29,0,56.94l-.11-.1,27.44,0,7.57,0H356l-.66,0h-2l-7.56,0-27.5,0h-.11v-.11c0-15.65,0-35.46,0-56.94v-.14h37.95v.13c0,16.78-.05,31-.06,41.09,0,5,0,9,0,11.7,0,1.35,0,2.39,0,3.1v.79A2.39,2.39,0,0,1,356,206.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.38,141.62a8.81,8.81,0,0,1-.89,1.3c-.58.77-1.41,1.83-2.35,3s-1.83,2.16-2.48,2.88a9.57,9.57,0,0,1-1.11,1.13,10.77,10.77,0,0,1,1-1.25l2.42-2.93,2.41-2.93A8.86,8.86,0,0,1,362.38,141.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.2,206.25a47,47,0,0,0,6.58,8.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.78,214.47a7,7,0,0,1-1.15-1,36.85,36.85,0,0,1-2.48-2.8,34.86,34.86,0,0,1-2.18-3,7.35,7.35,0,0,1-.77-1.35,8.81,8.81,0,0,1,.93,1.24c.55.78,1.33,1.84,2.23,3s1.78,2.13,2.41,2.84A10,10,0,0,1,362.78,214.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.09,214.25l6.56-8.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.65,206.15a50,50,0,0,1-3.17,4.13c-1.82,2.24-3.34,4-3.39,4a49,49,0,0,1,3.17-4.14A51.84,51.84,0,0,1,318.65,206.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.09,141.62a44.1,44.1,0,0,1,3.19,3.81,48.16,48.16,0,0,1,3,4,44.1,44.1,0,0,1-3.19-3.81A44.86,44.86,0,0,1,312.09,141.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.65,
    y: 161.05,
    width: 12.62,
    height: 35.83,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,345a17.86,17.86,0,0,0-10.5,9.23,31.5,31.5,0,0,0-3,13.92c-.12,9.27,3.89,19.15,8.55,27.16,8.55-5.74,11.81-17.22,13.1-23.15,2-9.38,0-27.55-8.14-27.16",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.19,409.27a15.23,15.23,0,0,0-3.06-15,20.19,20.19,0,0,0-14.2-6.5c-2.47-.13-5.21.25-6.87,2.09a6.51,6.51,0,0,0-.93,6.53,13.17,13.17,0,0,0,4.24,5.39c6.13,5,13,8.77,20.82,7.47",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.6,431.55a30.11,30.11,0,0,0-.28-6.12,28,28,0,0,0-1.52-6.52,62.39,62.39,0,0,0-3.07-7.57A30.4,30.4,0,0,0,241.21,400a22.32,22.32,0,0,0-4-2.17,5,5,0,0,0-1.59-.46c-.08.17,2.15,1,5.12,3.22a32.67,32.67,0,0,1,9,11.22,73.64,73.64,0,0,1,3.09,7.42,31.67,31.67,0,0,1,1.7,6.3C255.15,429.24,255.44,431.57,255.6,431.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.31,359a17.6,17.6,0,0,0-.7,3c-.38,2-.89,4.8-1.49,8.31-1.21,7-2.76,16.74-4.22,27.52s-2.49,20.57-3.09,27.68c-.3,3.55-.51,6.42-.62,8.41a16.28,16.28,0,0,0-.06,3.1,17.83,17.83,0,0,0,.46-3.06c.25-2.17.57-5,1-8.38.79-7.08,1.94-16.85,3.39-27.61s2.89-20.32,3.91-27.55c.48-3.38.87-6.2,1.17-8.35A17.92,17.92,0,0,0,265.31,359Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.35,414.25a35.62,35.62,0,0,1,25.59-20.1c2.82-.52,6.3-.42,7.85,2s.19,5.64-1.52,8A30.42,30.42,0,0,1,260.33,415",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,401.6a5,5,0,0,0-1.59.34c-1,.28-2.45.77-4.2,1.42a40,40,0,0,0-12.62,7.44,25.2,25.2,0,0,0-5,6.4,24.05,24.05,0,0,0-2.29,6.23,24.38,24.38,0,0,0-.56,4.42,4.84,4.84,0,0,0,0,1.63c.21,0,.29-2.31,1.22-5.87a24.88,24.88,0,0,1,7.3-12.05,45.07,45.07,0,0,1,12.2-7.52C279.91,402.55,282.08,401.76,282,401.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.59,169.76s-10.48-3.09-14.72,21-4.58,37.36-4.58,37.36-1.47,5.23-5.35,3.29-10.47-8.77-15.12-5.75c-4.83,3.13-4.76,9.57-1.09,17.93s11,27,11.68,28.68.44,4.45-2.41,3.56S403,264,398.3,273s9.36,30.56,10.85,33,1.32,3.66.28,4.68-6.8-3.23-12.1-6.13-11.95-5.33-14.21.05,2,23.52,27.82,47.23l12.66,10.2,15.33-5.64c32.07-14.08,42-29.84,41.62-35.67S473.07,315,467.12,316s-12.78,3.19-13.44,1.88-.4-2.56,1.79-4.34,22.48-17.7,20.95-27.67-22.27-5.5-25.26-5.58-2.27-2.79-1.13-4.14,14.17-16.62,20.35-23.35,8.33-12.79,4.78-17.32c-3.42-4.37-11.88,0-16.17.54s-4-4.84-4-4.84,4-12.66,7.77-36.84-7.4-24.6-7.4-24.6",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.76,191.35s0,.17-.05.51l-.21,1.49c-.2,1.33-.49,3.26-.85,5.72-.75,5-1.88,12.16-3.31,21-2.86,17.75-7,42.23-11.69,69.26s-8.9,51.5-11.85,69.23c-1.47,8.85-2.66,16-3.48,21-.41,2.46-.73,4.38-1,5.71-.11.63-.19,1.12-.26,1.48s-.11.5-.11.5,0-.17.06-.51.12-.85.2-1.49c.2-1.33.49-3.26.85-5.72.75-5,1.88-12.16,3.31-21,2.86-17.75,7-42.24,11.7-69.27S444,237.77,447,220c1.46-8.85,2.65-16,3.48-21l.95-5.71.26-1.48A4.51,4.51,0,0,1,451.76,191.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.66,235.62a5.25,5.25,0,0,1,.72.93c.44.62,1,1.53,1.78,2.66,1.47,2.27,3.42,5.45,5.5,9l5.29,9.13,1.61,2.75a4.16,4.16,0,0,1,.55,1,5.06,5.06,0,0,1-.73-.92c-.43-.62-1-1.53-1.76-2.67-1.45-2.29-3.36-5.5-5.44-9.05l-5.35-9.09c-.64-1.08-1.19-2-1.63-2.75A4.29,4.29,0,0,1,424.66,235.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.63,261c-.09-.13,6.3-4.43,14.27-9.62s14.48-9.28,14.57-9.16-6.31,4.44-14.27,9.62S441.71,261.11,441.63,261Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.57,302.16a5.47,5.47,0,0,1,1.13-.41l3.12-.95c2.63-.81,6.27-1.93,10.23-3.32s7.52-2.74,10.09-3.75l3-1.19a4.53,4.53,0,0,1,1.15-.38,5.59,5.59,0,0,1-1.06.57c-.7.34-1.71.81-3,1.36-2.52,1.1-6.06,2.53-10,3.91s-7.64,2.46-10.3,3.17c-1.34.35-2.42.62-3.18.79A5,5,0,0,1,432.57,302.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.17,282.6a4.57,4.57,0,0,1,.88.68c.54.46,1.32,1.14,2.26,2,1.9,1.71,4.49,4.09,7.33,6.74s5.39,5.08,7.22,6.86c.91.88,1.64,1.61,2.14,2.12a5.13,5.13,0,0,1,.74.83,3.92,3.92,0,0,1-.88-.67c-.55-.46-1.32-1.15-2.27-2-1.89-1.7-4.49-4.08-7.33-6.74s-5.39-5.08-7.21-6.85c-.92-.89-1.65-1.61-2.15-2.13A4.3,4.3,0,0,1,412.17,282.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.55,317.94a6.59,6.59,0,0,1,1.12.88l2.91,2.55c2.44,2.17,5.78,5.19,9.46,8.56s7,6.44,9.35,8.68l2.79,2.68a7.08,7.08,0,0,1,1,1,8,8,0,0,1-1.12-.88l-2.91-2.55c-2.44-2.17-5.78-5.2-9.46-8.56s-7-6.44-9.34-8.68L400.53,319A6.88,6.88,0,0,1,399.55,317.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.68,341.56a8.67,8.67,0,0,1,1.41-.55l3.92-1.35c3.3-1.14,7.86-2.73,12.85-4.62s9.46-3.71,12.68-5.05l3.83-1.59a8.3,8.3,0,0,1,1.43-.52,7.21,7.21,0,0,1-1.34.72c-.88.43-2.16,1-3.76,1.74-3.19,1.44-7.65,3.32-12.65,5.21S434.47,339,431.13,340c-1.67.52-3,.92-4,1.18A7.63,7.63,0,0,1,425.68,341.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.84,383.35c23.09-13.18,30.59-40.86,32-66.23.24-4.24,1.11-8.64-.56-12.53s-6.12-6.85-10.06-5.42c-3.27,1.19-5,4.71-7,7.57a24.84,24.84,0,0,1-10.77,8.55c-2.82,1.15-6.22,1.69-8.74,0-3.46-2.35-3.43-7.42-3-11.61Q96.9,291.92,98,280.2c.41-4.19.82-8.48-.12-12.58s-3.49-8.08-7.38-9.56-9.05.36-10.27,4.4c-.5,1.68-.32,3.48-.59,5.21s-1.27,3.59-3,3.93-3.29-1-4.43-2.35c-4-4.64-6.39-10.37-8.64-16.06s-4.41-11.48-7.92-16.47-8.61-9.14-14.59-10-12.73,2.24-14.79,8,.83,12.1,4.15,17.24A94.52,94.52,0,0,0,48.3,272.31c1.24,1.06,2.58,2.21,3,3.81.65,2.88-2.26,5.42-5.1,6.09-3.23.75-6.6.11-9.9.2s-7,1.2-8.51,4.19c-2.12,4.13,1.06,9,4.32,12.23a80.42,80.42,0,0,0,22.51,15.89c3,1.41,6.14,2.7,8.43,5.1s3.45,6.31,1.68,9.13-5.73,3.42-8.91,2.52-5.91-2.92-8.89-4.36c-5.57-2.71-13.06-3-17.21,1.65-2.73,3.06-3.36,7.6-2.49,11.62s3.05,7.62,5.41,11c8.25,11.7,19.29,21.52,32.26,27.39s25.24,8.26,39,4.62",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.46,402.13a186,186,0,0,0-3.69-35.24A379.19,379.19,0,0,0,87.54,325L84,314.19c-1.16-3.55-2.31-7.07-3.65-10.45a187.91,187.91,0,0,0-8.79-18.95c-3.09-5.89-6.23-11.37-9.21-16.47s-5.87-9.8-8.67-14A150.28,150.28,0,0,0,39,235.68c-1.9-2.06-3.42-3.61-4.47-4.65l-1.2-1.17a3.52,3.52,0,0,0-.43-.38,3.87,3.87,0,0,0,.37.43l1.15,1.23c1,1.07,2.5,2.66,4.36,4.75a158,158,0,0,1,14.45,18.78c2.77,4.17,5.61,8.88,8.57,14s6.08,10.6,9.14,16.48A192.25,192.25,0,0,1,79.69,304c1.32,3.36,2.46,6.85,3.61,10.41s2.32,7.16,3.51,10.82A389.79,389.79,0,0,1,98.07,367a189.2,189.2,0,0,1,3.84,35.1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.17,303.69a7.4,7.4,0,0,0,.58-1.75c.33-1.14.74-2.8,1.23-4.87,1-4.13,2.13-9.87,3.38-16.21s2.48-12.05,3.52-16.15c.51-2,.94-3.71,1.26-4.85a8.91,8.91,0,0,0,.4-1.8,7.85,7.85,0,0,0-.69,1.71c-.4,1.12-.92,2.76-1.5,4.8-1.18,4.07-2.5,9.79-3.75,16.14L81.44,297c-.39,1.95-.72,3.6-1,4.92A9.49,9.49,0,0,0,80.17,303.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.11,288.66a12.6,12.6,0,0,0,2.13.45c1.38.25,3.37.6,5.81,1.12,4.9,1,11.61,2.58,18.94,4.67s13.88,4.29,18.58,6c2.35.84,4.24,1.57,5.54,2.07a11.16,11.16,0,0,0,2.06.71,11.06,11.06,0,0,0-1.94-1c-1.27-.59-3.13-1.4-5.47-2.31-4.66-1.86-11.2-4.13-18.56-6.24a189.7,189.7,0,0,0-19.05-4.47c-2.46-.44-4.47-.71-5.86-.87A10.76,10.76,0,0,0,27.11,288.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.19,365.84a2.57,2.57,0,0,0,.43-.63l1.11-1.87c1-1.62,2.26-4,3.84-7,3.17-5.94,7.3-14.29,11.72-23.57s8.46-17.66,11.51-23.66l3.62-7.1,1-1.94a3.31,3.31,0,0,0,.29-.7,3,3,0,0,0-.43.62l-1.1,1.87c-.95,1.63-2.26,4-3.85,7-3.17,5.95-7.29,14.3-11.72,23.58s-8.46,17.65-11.5,23.66l-3.63,7.1-1,1.94A2.74,2.74,0,0,0,98.19,365.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.57,336.14a2.7,2.7,0,0,0,.69.36l2,.89,7.45,3.2c6.3,2.69,15,6.52,24.5,10.76s18.24,8,24.6,10.56c3.17,1.29,5.75,2.3,7.55,3l2.07.76a3.36,3.36,0,0,0,.74.21,2.49,2.49,0,0,0-.68-.36l-2-.89L88,361.4c-6.3-2.7-15-6.53-24.5-10.77s-18.25-8-24.6-10.56c-3.17-1.28-5.75-2.3-7.55-3l-2.07-.75A3.13,3.13,0,0,0,28.57,336.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.84 81.7 174.84 164.24 56.3 164.24 52.02 82.28 174.84 81.7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.4,
    y: 63.9,
    width: 81.78,
    height: 118.54,
    transform: "translate(-11.88 234.47) rotate(-90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.13,164.63H51.46V81.72H171.13ZM52.59,163.5H170V82.84H52.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.86,
    y: 92.44,
    width: 92.86,
    height: 61.46,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.73,92.44l-.46,0H156l-5.1,0-19.14.07-66.85.13.27-.27c0,18.78,0,39.59,0,61.46h0l-.3-.29,92.87.06-.24.23c.06-18.7.1-34,.13-44.71,0-5.34,0-9.51.06-12.37,0-1.41,0-2.5,0-3.25s0-1.13,0-1.13,0,.36,0,1.08,0,1.81,0,3.21c0,2.84,0,7,.06,12.31,0,10.71.07,26.1.12,44.86v.24h-.23l-92.87.06h-.29v-.3h0c0-21.87,0-42.68,0-61.46v-.27h.26l67,.14,19.08.07,5,0,1.29,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,82.05a10.38,10.38,0,0,1,2,1.32c1.22.88,2.87,2.12,4.65,3.55s3.35,2.77,4.46,3.78a9.49,9.49,0,0,1,1.69,1.74c-.11.13-3-2.22-6.52-5.07S51.92,82.19,52,82.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.57,82.28a57.14,57.14,0,0,1-6.24,5.31,56.89,56.89,0,0,1-6.6,4.85A58.61,58.61,0,0,1,164,87.13,57.34,57.34,0,0,1,170.57,82.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.47,164.08l-13.21-10.72",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.26,153.36a64.79,64.79,0,0,1,6.79,5.13,61.14,61.14,0,0,1,6.42,5.59,63.14,63.14,0,0,1-6.79-5.13C160,156,157.15,153.49,157.26,153.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,164.07a56.68,56.68,0,0,1,6.18-5.26,57.36,57.36,0,0,1,6.53-4.8,55.93,55.93,0,0,1-6.17,5.26A57.37,57.37,0,0,1,52,164.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.64,
    y: 92.67,
    width: 20.58,
    height: 58.43,
    transform: "translate(-8.95 234.82) rotate(-90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.18,
    y: 62.52,
    width: 63.38,
    height: 91.87,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.01,
    y: 62.52,
    width: 63.38,
    height: 91.87,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.88,
    y: 72.47,
    width: 47.63,
    height: 71.97,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.52,144.44s0-.12,0-.35v-1c0-.91,0-2.23,0-3.95,0-3.45,0-8.47,0-14.82,0-12.69-.05-30.67-.08-51.83l.16.16H389.88l.18-.17c0,27.15,0,52.18,0,72l-.14-.14,34.67.08,9.58,0,2.52,0h.87l-.84,0h-2.49l-9.55,0-34.76.07h-.13v-.14c0-19.79,0-44.82,0-72V72.3h48v.16c0,21.21-.05,39.21-.07,51.93,0,6.33,0,11.35-.05,14.79,0,1.7,0,3,0,3.91v1C437.52,144.33,437.52,144.44,437.52,144.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.57,62.52a10.11,10.11,0,0,1-1.13,1.64c-.74,1-1.78,2.33-3,3.78s-2.31,2.73-3.14,3.64A11.16,11.16,0,0,1,436.94,73a11.34,11.34,0,0,1,1.21-1.58l3.05-3.7c1.15-1.41,2.2-2.68,3.05-3.71A11.71,11.71,0,0,1,445.57,62.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.76,144.21a59.4,59.4,0,0,0,8.31,10.39",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.07,154.6a9.54,9.54,0,0,1-1.45-1.32c-.85-.86-2-2.09-3.14-3.53a47.16,47.16,0,0,1-2.75-3.84,9.69,9.69,0,0,1-1-1.7,12.51,12.51,0,0,1,1.17,1.57c.7,1,1.68,2.32,2.82,3.75s2.24,2.69,3.05,3.58A13.72,13.72,0,0,1,446.07,154.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,154.32l8.3-10.24",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.3,144.08a61.45,61.45,0,0,1-4,5.23c-2.3,2.82-4.22,5.07-4.29,5a63,63,0,0,1,4-5.23A63.4,63.4,0,0,1,390.3,144.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,62.52a58.22,58.22,0,0,1,4,4.82,58.82,58.82,0,0,1,3.76,5,56,56,0,0,1-4-4.82A58.82,58.82,0,0,1,382,62.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.73,
    y: 87.08,
    width: 15.95,
    height: 45.28,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M461.93,437c0,.15-97.42.26-217.55.26S26.81,437.19,26.81,437s97.39-.26,217.57-.26S461.93,436.9,461.93,437Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.7,264a17.27,17.27,0,0,1-5.15,16.9c-3.05,2.7-7,4.26-9.8,7.23a15.21,15.21,0,0,0-3.05,14.68,19.41,19.41,0,0,0,10.23,11.34,22.71,22.71,0,0,0,20.6-.7c7.73-4.37,12.23-13.14,13.37-21.95s-.65-17.73-3-26.3",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.19,419.35c8-1.31,15.5,1.13,23.42,2.88a14,14,0,0,0,6.49.35c3.43-.88,5.87-4.22,6.4-7.72a12.64,12.64,0,0,0-2-8.76,8.41,8.41,0,0,0-2.74-2.73,9.53,9.53,0,0,0-3.83-1,27.21,27.21,0,0,0-14.1,2.66,41.58,41.58,0,0,0-11.7,8.48c-1.68,1.68-1.18,3.61-1.92,5.87",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,290.23a62,62,0,0,1,.46-23,30.2,30.2,0,0,1,4-10.45,6.7,6.7,0,0,1,2.93-2.75,5.1,5.1,0,0,1,5.21,1.23A8.71,8.71,0,0,1,290,262a21.37,21.37,0,0,1-1.78,7.12c-3.09,7.9-8,14.46-13.25,21.1",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,319.14C431.81,320.43,472,407,472,407h0a17.07,17.07,0,0,0-10.25-1l-2.18.58a36.48,36.48,0,0,0-10.95,5l-11.47,7.76h0a3.28,3.28,0,0,1-1.63-2.53l0-.33L404.36,363Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.09,181.32l10.72,60.93c3.45,8.2,43.68,57.88,43.68,57.88l-13.3,42.74-52.84-72.25a27.61,27.61,0,0,1-7.44-19.38l2.06-65.1Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.14,290.58l27.59,2.09,24.06,3.73S430,307.49,430,312.11c0,1.54-11.52,38.23-18,60.21a152.82,152.82,0,0,0-3.88,16.24L430,437H326.17V392.59s-7-58.33-5.77-66.3S336.14,290.58,336.14,290.58Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,156.7a122.14,122.14,0,0,1,1.9-18.5c.15-.87.51-1.92,1.38-2,1.08-.14,1.63,1.25,1.77,2.33a65.19,65.19,0,0,1-.91,22.11",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.3,285.72c11.84-10.58,12.24-28.91,11.23-43.5a4.89,4.89,0,0,1,.46-3.13c1.13-1.61,3.88-1,5,.62s1,3.75.94,5.71c.61-1.66,3.21-1.65,4.43-.37s1.43,3.21,1.57,5l.39,4.88,34.59,33s.95-3,3.49-1.27,4.18,5.38,4.18,5.38l-24.37,53.19-45.23-55A18.37,18.37,0,0,1,278.3,285.72Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.24,322.53A45.86,45.86,0,0,0,317.3,338a28.2,28.2,0,0,0,.51,17.22A23.88,23.88,0,0,0,336.14,370",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.19,419.35,435.88,437h25.63l6-31.25h0a32.28,32.28,0,0,0-21.67,6.79Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.35,281.81a8.59,8.59,0,0,1,.56-1.41c.4-.88.94-2.18,1.55-3.8s1.26-3.58,1.87-5.78a69.11,69.11,0,0,0,1.51-7.29,67.79,67.79,0,0,0,.63-7.41c0-2.29,0-4.35-.14-6.08s-.27-3.12-.4-4.08a9.65,9.65,0,0,1-.14-1.51,7.58,7.58,0,0,1,.34,1.48,40.33,40.33,0,0,1,.57,4.08,55.83,55.83,0,0,1,.25,6.12,57.88,57.88,0,0,1-2.16,14.81,54.91,54.91,0,0,1-2,5.79c-.66,1.62-1.25,2.9-1.71,3.76A10,10,0,0,1,290.35,281.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.88,272.52A24.73,24.73,0,0,1,299,270a37.32,37.32,0,0,0,3-12.81,24.56,24.56,0,0,1,.15-2.75,10.35,10.35,0,0,1,.22,2.76,30.46,30.46,0,0,1-3,12.95A9.9,9.9,0,0,1,297.88,272.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.5,300.18c-.08-.05.34-.7.58-1.88a9.92,9.92,0,0,0-.26-4.63,34.71,34.71,0,0,0-1.73-4.42,7.56,7.56,0,0,1-.7-1.88,9,9,0,0,1,1,1.72,22.91,22.91,0,0,1,1.91,4.44,9.07,9.07,0,0,1,.11,4.86A3.57,3.57,0,0,1,338.5,300.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.49,370.62a2.06,2.06,0,0,1-.44-.25l-1.18-.78c-1-.69-2.49-1.7-4.23-3.07a36.26,36.26,0,0,1-5.61-5.37,21.52,21.52,0,0,1-4.34-8.45,26.57,26.57,0,0,1-.58-9.5,37.51,37.51,0,0,1,1.71-7.57,49.45,49.45,0,0,1,1.91-4.87c.26-.56.46-1,.61-1.28a2.21,2.21,0,0,1,.25-.44,17,17,0,0,1-.67,1.8c-.45,1.14-1.1,2.8-1.75,4.9a39.71,39.71,0,0,0-1.58,7.51,26.74,26.74,0,0,0,.6,9.32,21.34,21.34,0,0,0,4.21,8.28,38,38,0,0,0,5.47,5.38c1.7,1.4,3.13,2.45,4.12,3.2l1.12.86C332.37,370.49,332.5,370.6,332.49,370.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.14,380.51a1.71,1.71,0,0,1-.44.16c-.3.08-.73.23-1.3.34a26.4,26.4,0,0,1-4.9.59,27.53,27.53,0,0,1-26.07-16.49,25.89,25.89,0,0,1-1.57-4.68c-.14-.57-.19-1-.25-1.32a2.09,2.09,0,0,1-.05-.47,13.64,13.64,0,0,1,.5,1.73,28,28,0,0,0,27.43,20.86,30.17,30.17,0,0,0,4.87-.42A17.13,17.13,0,0,1,389.14,380.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.05,400c-.14,0,1.18-5.57,3-12.35s3.32-12.25,3.45-12.21-1.18,5.56-2.95,12.34S405.19,400,405.05,400Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,388.21c-.12.07-4.14-6.5-9-14.68s-8.66-14.87-8.53-14.94,4.14,6.49,9,14.67S419.17,388.13,419,388.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.39,404.4c0,.1-1.46.22-3.74.8a29.5,29.5,0,0,0-3.91,1.29,32.57,32.57,0,0,0-4.48,2.32,31.63,31.63,0,0,0-4,3.05,29.37,29.37,0,0,0-2.85,3c-1.5,1.81-2.24,3.08-2.33,3a4.45,4.45,0,0,1,.47-.92,18.58,18.58,0,0,1,1.57-2.34,26.78,26.78,0,0,1,2.81-3.1,28.94,28.94,0,0,1,4.06-3.14,29.47,29.47,0,0,1,4.58-2.32,25.43,25.43,0,0,1,4-1.21,18.11,18.11,0,0,1,2.78-.42A3.63,3.63,0,0,1,457.39,404.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.29,398.38c0,.11-1.61-.09-4.18.13a26.89,26.89,0,0,0-4.44.78,26.93,26.93,0,0,0-9.8,4.91,27.05,27.05,0,0,0-3.28,3.09c-1.71,1.92-2.51,3.32-2.6,3.27a4.58,4.58,0,0,1,.53-1,9.66,9.66,0,0,1,.72-1.11,17.53,17.53,0,0,1,1.07-1.4,24.3,24.3,0,0,1,3.26-3.22,28,28,0,0,1,4.72-3.06,27.56,27.56,0,0,1,5.26-1.94,24.14,24.14,0,0,1,4.54-.69,17.43,17.43,0,0,1,1.75,0,11.86,11.86,0,0,1,1.33.08A4.47,4.47,0,0,1,462.29,398.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M355.63,360.77c-2.35,4.46-.39,9.9,1.76,14.47,1.67,3.54,3.53,7.13,6.57,9.6A14,14,0,0,0,384.31,382a31.59,31.59,0,0,1-29.16-20.63"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M401.54,358.59c-1.8,4.29-.44,10.16,1.44,14.41s3.88,9,2.37,13.41a5.64,5.64,0,0,0-.59,2.52c.1.86,1,1.69,1.81,1.29a2,2,0,0,0,.81-1.24q2.13-6.42,4.27-12.83"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M306.94,302.1a62.61,62.61,0,0,1,1-8,62.17,62.17,0,0,1,1.53-7.88,59.18,59.18,0,0,1-1,8A61.06,61.06,0,0,1,306.94,302.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.41,299.89c-.13.08-1.85-2.32-4.23-5.08s-4.48-4.83-4.38-4.94a24.68,24.68,0,0,1,4.78,4.6A25.61,25.61,0,0,1,296.41,299.89Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.45,274.13a8.62,8.62,0,0,1-1.13,1.8c-.76,1.07-1.87,2.5-3.16,4s-2.53,2.85-3.46,3.77a8.09,8.09,0,0,1-1.59,1.4c-.11-.1,2.08-2.47,4.65-5.51S305.33,274,305.45,274.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.92,261.54c-.15.06-.72-1.21-1.82-2.48s-2.28-2-2.2-2.15a4.88,4.88,0,0,1,2.59,1.81A5,5,0,0,1,301.92,261.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.8,269.3a7.18,7.18,0,0,1-2.6.67,6.9,6.9,0,0,1-2.68.16,14,14,0,0,1,5.28-.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.81,280.41a27.31,27.31,0,0,0-.33-4.65,26.55,26.55,0,0,0-1.63-4.37,7.85,7.85,0,0,1,2.13,4.26A8,8,0,0,1,315.81,280.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.1,293.63a23.42,23.42,0,0,0-7.25-7.31,12.64,12.64,0,0,1,7.25,7.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.37,316.57a12,12,0,0,1-9.17-.31c.05-.15,2,.48,4.57.55S308.33,316.42,308.37,316.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.63,321.32c-.14-.06.64-2.36,1.29-5.28s.94-5.34,1.09-5.32a16.87,16.87,0,0,1-.58,5.43A17.06,17.06,0,0,1,317.63,321.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.86,322.09a35.61,35.61,0,0,1-4.37-4.4,37.36,37.36,0,0,1-4-4.76,36.5,36.5,0,0,1,4.36,4.41A38.62,38.62,0,0,1,337.86,322.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.28,345.46a19.11,19.11,0,0,1-3.26-3,19.54,19.54,0,0,1-2.88-3.36,19.11,19.11,0,0,1,3.26,3A18.12,18.12,0,0,1,347.28,345.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.77,347.69a14.52,14.52,0,0,1-4,3,14.15,14.15,0,0,1-4.62,2c0-.14,2-1,4.36-2.41S329.67,347.57,329.77,347.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.83,369.92c-.15,0,.45-2.66.75-5.95s.21-6,.36-6a19.21,19.21,0,0,1,.16,6A18.93,18.93,0,0,1,337.83,369.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.14,351.85a16.81,16.81,0,0,1-4.33-3.81,16.39,16.39,0,0,1-3.19-4.79c.13-.09,1.5,2.08,3.58,4.45S368.24,351.72,368.14,351.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.21,361.28c-.12-.09,1.4-2.17,3.1-4.84s2.95-4.91,3.08-4.84a21.45,21.45,0,0,1-2.65,5.12A20.86,20.86,0,0,1,379.21,361.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.59,338.2a52.34,52.34,0,0,1-10-2.7,27.52,27.52,0,0,1,5.08,1.1A25.61,25.61,0,0,1,377.59,338.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.52,378.82a21.2,21.2,0,0,1,0-4.74,22.4,22.4,0,0,1,.54-4.71,20.88,20.88,0,0,1,0,4.74A22,22,0,0,1,369.52,378.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.5,392.73a40.18,40.18,0,0,0,1.26-4.93,38.69,38.69,0,0,0,.08-5.09,12,12,0,0,1-1.34,10Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.41,389.66a15.43,15.43,0,0,1,1.92-10c.14.06-.78,2.17-1.3,4.94S358.56,389.65,358.41,389.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.91,396.71a56,56,0,0,1-4.7-3.65,58.07,58.07,0,0,1-4.63-3.73,24.28,24.28,0,0,1,5,3.32A25.41,25.41,0,0,1,341.91,396.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.08,377.09a86.36,86.36,0,0,1-12,6.35A44.9,44.9,0,0,1,347,380,43.67,43.67,0,0,1,353.08,377.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.79,421.12a4.53,4.53,0,0,1-.65.16c-.43.08-1.06.24-1.88.35a40.12,40.12,0,0,1-7,.45,42.79,42.79,0,0,1-31.8-14.86,43.15,43.15,0,0,1-5.85-8.66,39.56,39.56,0,0,1-2.68-6.51c-.27-.79-.4-1.42-.52-1.84a3.16,3.16,0,0,1-.13-.66,3.66,3.66,0,0,1,.23.63c.15.41.31,1,.61,1.81a45.3,45.3,0,0,0,8.7,14.91,43.92,43.92,0,0,0,31.45,14.81,45.49,45.49,0,0,0,7-.28c.83-.08,1.46-.21,1.89-.25A2.82,2.82,0,0,1,387.79,421.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.91,415.94a7.77,7.77,0,0,1,.47-4.73,7.69,7.69,0,0,1,2.76-3.87,24.61,24.61,0,0,0-2.27,4.06A25.36,25.36,0,0,0,357.91,415.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.68,412.5a17.46,17.46,0,0,0-2.6,2.48,18.28,18.28,0,0,0-1.64,3.19,6.13,6.13,0,0,1,4.24-5.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.33,431.34a10.24,10.24,0,0,1-8-5,18,18,0,0,0,8,5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.25,403.64a7.88,7.88,0,0,1-5.43,6.4,21.35,21.35,0,0,0,3.24-2.75A20.67,20.67,0,0,0,386.25,403.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.24,424.29c-.12-.1,1.2-1.77,2.42-4.07s1.87-4.33,2-4.28a15.38,15.38,0,0,1-4.44,8.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.73,427c.06.15-1.76.87-3.59,2.38s-2.93,3.13-3.06,3a8.11,8.11,0,0,1,2.73-3.45A8,8,0,0,1,418.73,427Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.63,403.33c-.16.05-1-2.87-2.87-6.11s-3.87-5.52-3.74-5.62a6.24,6.24,0,0,1,1.43,1.4,24.83,24.83,0,0,1,4.72,8.38A6.62,6.62,0,0,1,404.63,403.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.39,373.56a46.44,46.44,0,0,1-9.6,2.21,46.84,46.84,0,0,1,9.6-2.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.88,364.66a22,22,0,0,1-3.06-3.52,21.71,21.71,0,0,1-2.65-3.83,20.09,20.09,0,0,1,3.06,3.51A20.35,20.35,0,0,1,398.88,364.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,359.32a23.29,23.29,0,0,1-9.36-2.22,40.77,40.77,0,0,1,4.69,1.09A39.56,39.56,0,0,1,420,359.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,359.05a38.75,38.75,0,0,1,1.53-4.16,35.4,35.4,0,0,1,1.53-4.17,13.07,13.07,0,0,1-1,4.35A12.74,12.74,0,0,1,435,359.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.58,379.37a15,15,0,0,1-8-4.74c.1-.12,1.68,1.26,3.87,2.55S431.63,379.22,431.58,379.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.32,378.75a36.24,36.24,0,0,1,1.1-5.94A35.63,35.63,0,0,1,444,367a69.63,69.63,0,0,1-2.71,11.76Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.19,401.47a61.12,61.12,0,0,1-6.66-9.11,31.24,31.24,0,0,1,3.54,4.4A30.65,30.65,0,0,1,433.19,401.47Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.07,392.78c-.14.07-1.05-1.74-2.49-3.76s-2.83-3.49-2.72-3.6a11.62,11.62,0,0,1,3.15,3.3A11.28,11.28,0,0,1,447.07,392.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.09,390.83a49.66,49.66,0,0,1-3.2-4.19,52.09,52.09,0,0,1-3.2-4.18,27.1,27.1,0,0,1,6.4,8.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457,399.46a9.64,9.64,0,0,0-1.19-3.41,9.85,9.85,0,0,0-2.67-2.44c0-.06.46,0,1.09.31a5.4,5.4,0,0,1,2,1.84,5.49,5.49,0,0,1,.89,2.58C457.22,399,457.09,399.46,457,399.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.88,411.29c-.08,0-.05-.27-.13-.62a2.05,2.05,0,0,0-.69-1.15,2,2,0,0,0-1.28-.39c-.36,0-.59.09-.63,0s.15-.27.58-.39a1.9,1.9,0,0,1,2.38,1.86C447.1,411.08,446.94,411.31,446.88,411.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.84,430.2A14.41,14.41,0,0,1,334.6,422a24.36,24.36,0,0,0,8.24,8.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.19,182c-1.61-15.21-4.52-29.52-5.31-44.43a2.7,2.7,0,0,0-.71-2.06,1.86,1.86,0,0,0-2.59.75,5.68,5.68,0,0,0-.5,3,68.82,68.82,0,0,1-4,23.27c-1.71,4.85-4,9.5-5.28,14.47s1.13,6.66,3.37,11.29",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.2,188.27a13.93,13.93,0,0,1-5.29-13.17c.51-3,2-5.72,3.18-8.52s2.09-5.91,1.37-8.86a14.92,14.92,0,0,1-.8-3.39c0-1.16.75-2.46,1.91-2.51a2.84,2.84,0,0,1,2.17,1.31c1.95,2.41,3.51,9.45,2.53,14.71",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.27,167.84s.1-.81.16-2.27a27.24,27.24,0,0,0-.51-6.14,22.23,22.23,0,0,0-1.2-4.07,8.24,8.24,0,0,0-1.12-2,2.85,2.85,0,0,0-1.87-1.27,1.8,1.8,0,0,0-1.67,1.4,4.24,4.24,0,0,0,.16,2.57,13.32,13.32,0,0,1,.7,2.83,11.33,11.33,0,0,1-.11,3c-.7,4.06-2.86,7.34-4,10.59a14.35,14.35,0,0,0-.89,4.74,13.87,13.87,0,0,0,.62,4.16,14.27,14.27,0,0,0,3,5.31c1,1.07,1.65,1.54,1.62,1.59a2.64,2.64,0,0,1-.5-.33,11.13,11.13,0,0,1-1.27-1.13,13.68,13.68,0,0,1-3.2-5.33,13.84,13.84,0,0,1-.7-4.27,14.66,14.66,0,0,1,.87-4.9c1.1-3.32,3.23-6.6,3.89-10.51a10.36,10.36,0,0,0,.11-2.88,12.69,12.69,0,0,0-.67-2.75,4.69,4.69,0,0,1-.14-2.87,2.78,2.78,0,0,1,.79-1.23,1.84,1.84,0,0,1,1.38-.49A3.27,3.27,0,0,1,267,153a8.74,8.74,0,0,1,1.16,2.16,21,21,0,0,1,1.16,4.16,24.7,24.7,0,0,1,.35,6.22,12.45,12.45,0,0,1-.22,1.68A2.27,2.27,0,0,1,269.27,167.84Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,249.05a6.9,6.9,0,0,0,6.17,5.34,8.66,8.66,0,0,0,7.53-3.7,11.67,11.67,0,0,0,1.87-8.36c-.57-4.21-3.37-8.26-7.43-9.51s-9.11,1-10.23,5.08l-4.68,6.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.47,236.22A27.23,27.23,0,0,0,370,205.72c-14.51-1.38-27.42,9.43-29.59,23.85-1.91,12.64-3.55,25.4-3.49,30,.18,14,8.35,19.42,11.67,21a18.34,18.34,0,0,0,3.68.91h0a.09.09,0,0,1,.07.11l-3.1,16c-1.41,10.51,4.46,19.89,14.95,21.42s18.76-6.54,20.37-17.06Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.82,237.74c.23.33,2.07-.66,4.44-.31s3.92,1.79,4.22,1.53c.15-.11-.06-.66-.73-1.32a6.12,6.12,0,0,0-3.33-1.59,5.92,5.92,0,0,0-3.59.61C343,237.11,342.7,237.59,342.82,237.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.86,242.3c.23.33,2.08-.66,4.44-.31s3.93,1.79,4.23,1.53c.14-.11-.06-.66-.74-1.33a6.11,6.11,0,0,0-3.32-1.58,5.91,5.91,0,0,0-3.59.61C364.07,241.67,363.75,242.15,363.86,242.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.68,253.48a15.93,15.93,0,0,0-3.74-1.25c-.6-.15-1.15-.36-1.19-.78a3.11,3.11,0,0,1,.66-1.73l2.46-4.34c3.43-6.19,6-11.31,5.76-11.45s-3.24,4.77-6.67,11l-2.39,4.37a3.65,3.65,0,0,0-.66,2.33,1.57,1.57,0,0,0,.87,1,4.32,4.32,0,0,0,1,.29A15.57,15.57,0,0,0,355.68,253.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.36,281.58s9,2.08,21.45-3.12c0,0-5.36,11.55-22.28,7.44Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.85,259.33a4.31,4.31,0,0,1,4-1,4,4,0,0,1,2.48,1.84,2.47,2.47,0,0,1-.23,2.84,2.86,2.86,0,0,1-3.21.33,8.88,8.88,0,0,1-2.76-2.24,2.53,2.53,0,0,1-.58-.8.78.78,0,0,1,.14-.88",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.4,256.13c-.38-.08-.76,2.49-3.22,4s-5.16.82-5.23,1.18c-.06.16.54.59,1.69.79a6.48,6.48,0,0,0,4.34-.84,5.64,5.64,0,0,0,2.54-3.37C362.77,256.82,362.58,256.14,362.4,256.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.49,234.6c.14.68,2.55.72,5.27,1.46s4.87,1.82,5.32,1.3c.2-.25-.1-.91-.91-1.67a9.52,9.52,0,0,0-8.07-2.1C366,233.85,365.44,234.28,365.49,234.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.21,230.45c.33.6,2.05.28,4,.54s3.57.88,4,.38c.21-.25,0-.83-.63-1.44a5.84,5.84,0,0,0-6.48-.74C345.37,229.64,345.06,230.16,345.21,230.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.67,226.44c2.89,4.41,12.07,1.68,17.61-1.35a13.18,13.18,0,0,0,18-3.72c3.17,4,9.62,2.7,12-1.85s1-10.82-2.2-14.8-7.94-6-12.6-6.85c-11.05-2-23.08,2.24-29.69,12.23-3.05,4.61-4.88,10.82-3.07,16.34",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.21,199.44c0,.2-2.61-.3-6.71.38a24.4,24.4,0,0,0-13.88,7.47A30.24,30.24,0,0,0,341,221.75a40,40,0,0,0-.35,6.7,6.13,6.13,0,0,1-.37-1.8,20.76,20.76,0,0,1,.08-5,29.13,29.13,0,0,1,6.62-15,24,24,0,0,1,14.48-7.51,21.29,21.29,0,0,1,5-.08A5.87,5.87,0,0,1,368.21,199.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.27,220a4.54,4.54,0,0,1-.22-1.57,15.51,15.51,0,0,1,.45-4.31A17.75,17.75,0,0,1,375.78,201a16.23,16.23,0,0,1,4,1.7,4.34,4.34,0,0,1,1.27,1,32.68,32.68,0,0,0-5.42-2,17.71,17.71,0,0,0-21.5,12.66C353.15,217.7,353.46,220,353.27,220Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.78,215.2a52.27,52.27,0,0,0-1.86,12,17.67,17.67,0,0,0,3.59,11.34c3.86,4.65,10.3,6.07,16.24,7.2a47,47,0,0,0,2.77-25c-.68-4.09-2-8.26-4.88-11.24a13.59,13.59,0,0,0-16.5-2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.08,234.56c-1.56,3.38-1.45,7.29-.91,11s1.48,7.34,1.44,11.06-1.22,7.67-4.14,10a17.59,17.59,0,0,0-2.48,2,2.59,2.59,0,0,0-.52,2.93c.56.9,2.25.88,2.49-.15l-.15.26a1.65,1.65,0,0,0,1.4,2.49,7.49,7.49,0,0,0,5.34-2.62c1.91-2.21,2.67-5.18,3.17-8,1.54-8.83,1.24-18,3.68-26.61",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.17,292.55a21.51,21.51,0,0,0,28.73,15.26c5.18-2,9.36-5.9,13.39-9.71a31.37,31.37,0,0,1-29.07,36.46c-6.63.4-13.75-1.62-17.92-6.79-2.91-3.6-4.08-8.37-4-13a47.36,47.36,0,0,1,2.62-13.6c1.18-3.78,3.05-8,6.87-9.05",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.61,246c4,2.15,6.14,6.65,6.91,11.09s.38,9,.57,13.49,1.05,9.21,3.9,12.7c3,3.72,7.75,5.48,12,7.75,9.32,5,17,13.53,19.8,23.75s.26,22-7.39,29.35c-7,6.66-17.1,9-26.74,9-6.87,0-14.42-1.48-18.71-6.85s-4-12.9-2.5-19.52,4.25-13.05,4.36-19.84a35.35,35.35,0,0,1-5.28,11.74c-.71,1-1.92,2.1-3,1.52s-.75-2.45-.19-3.7c8.28-18.43,5.4-55.58,10.31-75.93",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.79,243.91c.25-.08,9.92-1.91,8.67,7.65s-10.58,6.34-10.56,6.07S389.79,243.91,389.79,243.91Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.29,254.39s.15.13.42.3a1.69,1.69,0,0,0,1.24.19c1.06-.24,2.12-1.74,2.39-3.45a5.67,5.67,0,0,0-.16-2.45,1.93,1.93,0,0,0-1.09-1.44.86.86,0,0,0-1,.33c-.16.25-.13.45-.18.46s-.18-.19-.06-.57a1.07,1.07,0,0,1,.46-.55,1.26,1.26,0,0,1,1-.13,2.37,2.37,0,0,1,1.55,1.71,5.78,5.78,0,0,1,.23,2.74c-.31,1.92-1.53,3.59-3,3.81a1.78,1.78,0,0,1-1.49-.45C391.28,254.62,391.26,254.4,391.29,254.39Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.29,313.15a23.62,23.62,0,0,1,1.62-2.95,39.81,39.81,0,0,0,3.45-7.29,18,18,0,0,0,.86-7.92,30.93,30.93,0,0,0-.76-3.25,2.7,2.7,0,0,1,.43.81,10.62,10.62,0,0,1,.7,2.39,17,17,0,0,1-.73,8.13,33.58,33.58,0,0,1-3.63,7.32c-.56.88-1,1.58-1.37,2.05S339.32,313.17,339.29,313.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.16,302.12c-.14,0-.41-.82-1.27-1.39s-1.72-.57-1.74-.72.21-.17.6-.18a2.51,2.51,0,0,1,1.44.47,2.63,2.63,0,0,1,.94,1.19C344.26,301.86,344.23,302.1,344.16,302.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.34,302.1a18.83,18.83,0,0,0-2.46-2.31,16.54,16.54,0,0,0-3.1-1.34,4.49,4.49,0,0,1,3.38.91A4.64,4.64,0,0,1,350.34,302.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.22,322.39a16.61,16.61,0,0,1,.58-4.08,16.43,16.43,0,0,1,1.09-4,16.66,16.66,0,0,1-.58,4.09A16.43,16.43,0,0,1,354.22,322.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.82,325.45a36.5,36.5,0,0,1,.27-8.61,35.13,35.13,0,0,1-.27,8.61Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "51.31 369.89 35.89 437.04 68.5 437.14 83.56 378.09 51.31 369.89",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.45,287.39c-3.1-4.15-6.66-8.14-8.29-13.06-.79-2.38-1.1-4.9-1.94-7.26s-2.37-4.66-4.71-5.55-4.12,0-5.64,1.68l-11.19,32.73,6.45,25.14c6.44-1.45,14.5-3.17,20.52-5.88s10-7.05,10.42-13.64C217.36,296.38,214.55,291.55,211.45,287.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.62,281.61s-38.9,16.93-43.76,24.57S45,368.29,45,368.29l41,12L85.3,437H185.8l-.83-100-12.6-55.26s-22.19-1.43-24.25-2.44S109.62,281.61,109.62,281.61Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.86,143c.32-2.29-1.29-4.81-.13-6.82a5.68,5.68,0,0,1,3.11-2.11,5,5,0,0,1,1.92-.45,1.69,1.69,0,0,1,1.57,1,2.14,2.14,0,0,1-.77,2.07,6.1,6.1,0,0,0-1.51,1.74,10.44,10.44,0,0,0,.37,4.92,86.93,86.93,0,0,1,3.31,10.7",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.65,143.78c.14-3.47,3-17.14,3.1-20.61,2.35.72,3.71,3.22,4.15,5.64s.21,4.91.63,7.33c.56,3.25,2.25,6.18,3.95,9s3.48,5.69,4.25,8.89,3.67,11.52,1.41,13.92",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,167.18l-13.91,66.08c-.49,3-52.72,48.55-52.72,48.55L182.68,323l68-66.53a27.64,27.64,0,0,0,7.45-19.39l-1.16-62Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.62,144.2l2.38,23,18,7.92s.22-1.63,1-9.6c.85-8.78-8.59-12.55-12.8-19-1.8-2.77-1.33-7.87-2.72-14.19-.16-.73-1.16-5.15-1.7-7.52a5.34,5.34,0,0,0-2.16-3.25c-.82-.54-1.74-.81-2.41,0S236.62,144.2,236.62,144.2Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.86,171c2-1.73,2.48-4.83,1.73-7.4a18.87,18.87,0,0,0-4.25-6.76,26.82,26.82,0,0,1-4.69-6.5c-.76-1.72-1.12-3.62-2-5.31s-2.37-3.24-4.25-3.31c1.51,9.51,1.47,15,4.56,25.42",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.27,152.58s-.07-.26-.18-.76-.3-1.33-.48-2.18c-.43-2-1-4.55-1.59-7.48l-.06-.28.29,0a4.66,4.66,0,0,1,3.36,1.26,10.09,10.09,0,0,1,2.82,4.81A24.94,24.94,0,0,0,242,152.1a12.8,12.8,0,0,0,1.76,2.43,3.63,3.63,0,0,1,.6.95,7.37,7.37,0,0,1-.76-.82,11.36,11.36,0,0,1-1.92-2.38,23.58,23.58,0,0,1-1.72-4.19,9.89,9.89,0,0,0-2.7-4.58,4.25,4.25,0,0,0-3-1.15l.24-.3C235.71,148.08,236.49,152.59,236.27,152.58Z",
    style: {
      fill: "#7c5142"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.36,146.73a86.18,86.18,0,0,1-1.66-9.38,87.17,87.17,0,0,1-1.15-9.46,83.85,83.85,0,0,1,1.66,9.39A87.15,87.15,0,0,1,244.36,146.73Z",
    style: {
      fill: "#7c5142"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09,147.51s.07.1.13.35l-.15,0a53.84,53.84,0,0,1-1.82-6.54c-.43-1.93-.74-3.69-.93-5a7.75,7.75,0,0,1-.18-2.09c.15,0,.76,3.11,1.62,7,.69,3.11,1.33,5.73,1.46,6.61l-.15,0C250.06,147.63,250.06,147.51,250.09,147.51Z",
    style: {
      fill: "#7c5142"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.64,160.18c-.08,0-.44-.52-1.16-1.29a11.25,11.25,0,0,0-7.25-3.5,12,12,0,0,1-1.73-.11,4,4,0,0,1,1.74-.26,9.84,9.84,0,0,1,7.51,3.63A3.92,3.92,0,0,1,253.64,160.18Z",
    style: {
      fill: "#7c5142"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.63,169a13.61,13.61,0,0,1-1.19-2.72,60.3,60.3,0,0,1-2.06-6.86,59.39,59.39,0,0,1-1.26-7,14.52,14.52,0,0,1-.18-3,20.21,20.21,0,0,1,.54,2.91c.3,1.79.76,4.27,1.4,7s1.36,5.12,1.91,6.86A21.08,21.08,0,0,1,240.63,169Z",
    style: {
      fill: "#7c5142"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.16,283a6.34,6.34,0,0,1,8.52-2c7.34-6,14.85-11.82,22.19-17.79-2.4,12-4,28.73,1.37,39.71,0,0,6.77,12.58,17.55,10.66L200.17,323,185,337.07",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.78,288.6a8.1,8.1,0,0,1,1.41-4.51,8.19,8.19,0,0,1,3.36-3.34,17.53,17.53,0,0,0-4.77,7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.71,296a6.17,6.17,0,0,1-.84-2.18,14.1,14.1,0,0,1,1.93-10.91,6.26,6.26,0,0,1,1.54-1.77c.07.06-.51.74-1.22,2a15.9,15.9,0,0,0-1.89,5.15,16.16,16.16,0,0,0,0,5.49C165.48,295.08,165.79,295.92,165.71,296Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.45,321.68a8.12,8.12,0,0,1-2.39,1,13.29,13.29,0,0,1-7-.21,16.86,16.86,0,0,1-8.42-6,28.34,28.34,0,0,1-5-11.71,88.35,88.35,0,0,1-1.2-23.12c.23-3,.56-5.34.84-7,.13-.82.25-1.45.34-1.88a3.29,3.29,0,0,1,.16-.65,2.8,2.8,0,0,1-.06.67l-.24,1.89c-.21,1.64-.49,4-.67,7a92.69,92.69,0,0,0,1.34,23A28.24,28.24,0,0,0,185,316.1a16.52,16.52,0,0,0,8.15,6,13.46,13.46,0,0,0,6.85.37A19.2,19.2,0,0,0,202.45,321.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.19,397.17c-.14,0-.26-14.22-.26-31.75s.12-31.75.26-31.75.26,14.21.26,31.75S86.34,397.17,86.19,397.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.39,322.7c-.11,0-.08-1.42-.57-3.63a20.12,20.12,0,0,0-1.25-3.76,22.59,22.59,0,0,0-2.47-4.16,22.85,22.85,0,0,0-3.37-3.48,20.68,20.68,0,0,0-3.29-2.2c-2-1.05-3.39-1.4-3.36-1.5a3.5,3.5,0,0,1,1,.2,7.55,7.55,0,0,1,1.11.37,10.91,10.91,0,0,1,1.43.61A18.35,18.35,0,0,1,78,307.29a22.46,22.46,0,0,1,3.47,3.54,21.26,21.26,0,0,1,2.5,4.29A18.5,18.5,0,0,1,85.18,319a12.22,12.22,0,0,1,.21,1.54,8.54,8.54,0,0,1,.06,1.17A4.31,4.31,0,0,1,85.39,322.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.88,281.17a4.65,4.65,0,0,1,.17.85,20.87,20.87,0,0,1,.26,2.45,25.5,25.5,0,0,1-1.25,8.95,26.26,26.26,0,0,1-7.25,11.22A25.81,25.81,0,0,1,115,307a26.24,26.24,0,0,1-8.84-10,25.59,25.59,0,0,1-2.57-8.66,22.65,22.65,0,0,1-.11-2.46,5.12,5.12,0,0,1,0-.86,5.12,5.12,0,0,1,.07.85,24.31,24.31,0,0,0,.2,2.44,26.42,26.42,0,0,0,2.7,8.52,26.1,26.1,0,0,0,8.77,9.79,25.5,25.5,0,0,0,30.22-2.27,26.09,26.09,0,0,0,7.22-11,26.77,26.77,0,0,0,1.4-8.83c0-1.06-.09-1.88-.17-2.44S153.87,281.18,153.88,281.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.33,367.93c0,.14-8.31-2.47-18.45-5.82s-18.33-6.18-18.28-6.32,8.3,2.47,18.45,5.82S85.37,367.79,85.33,367.93Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,354.05c0,.15-22.05.36-49.25.47s-49.26.09-49.26,0,22.05-.36,49.26-.47S184,353.91,184,354.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.5,362.76c0,.14-22.17.26-49.5.26s-49.51-.12-49.51-.26,22.16-.26,49.51-.26S184.5,362.61,184.5,362.76Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.92,373.34a4.55,4.55,0,0,1-.28.81c-.22.56-.52,1.32-.89,2.28l-.66,1.64c-.26.6-.57,1.23-.89,1.92-.66,1.36-1.34,2.94-2.29,4.6l-1.44,2.62c-.5.91-1.1,1.81-1.68,2.77-1.14,1.93-2.54,3.87-4,5.94a107.83,107.83,0,0,1-10.7,12.4,107.47,107.47,0,0,1-12.61,10.46c-2.1,1.4-4.07,2.77-6,3.87-1,.56-1.88,1.14-2.8,1.63L124,425.66c-1.67.91-3.27,1.57-4.64,2.2-.69.3-1.33.6-1.93.85l-1.66.63-2.29.85a4.39,4.39,0,0,1-.82.26,5.19,5.19,0,0,1,.78-.36l2.26-.94,1.63-.67c.6-.26,1.23-.57,1.91-.89,1.36-.65,2.94-1.33,4.59-2.26l2.63-1.4c.91-.5,1.82-1.09,2.78-1.65,1.93-1.11,3.88-2.49,6-3.89a101.27,101.27,0,0,0,23.2-22.75c1.45-2.05,2.86-4,4-5.89.59-.95,1.2-1.84,1.71-2.74l1.45-2.6c1-1.63,1.67-3.2,2.35-4.55.33-.68.66-1.3.93-1.89s.49-1.13.7-1.62c.41-.94.74-1.68,1-2.24A8.22,8.22,0,0,1,170.92,373.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M166.86,382c-6.72,8.18-13.76,14.11-23.63,17.93-4.73,1.82-9.68,3.07-14.26,5.24s-8.9,5.44-11,10.07c-1.59,3.58-.82,9,3,9.78a8.11,8.11,0,0,0,4.35-.67c19.55-7.09,32.4-25,41.48-42.35"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.93,204.08c-4.22,3.31-4.5,9.5-4.29,14.86S92.91,230.4,89,234.1c-3.2,3.05-8.8,4.18-9.72,8.51a5,5,0,0,0,8.08,4.95c-1.36,3.39-.74,7.73,2.15,10s7.94,1.19,9-2.29a4.42,4.42,0,1,0,8.6,2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.17,242.89a5.33,5.33,0,1,0,10-3.62c-.83-2.08-3-3.65-3.05-5.88-.13-2.7,2.71-4.49,5.2-5.54s5.41-2.45,5.8-5.12-1.84-4.72-3.7-6.55-3.65-4.61-2.34-6.87c.67-1.15,2-1.77,2.86-2.78,1.94-2.24,1.16-6-1.08-7.91s-5.45-2.35-8.38-2-5.73,1.45-8.6,2.16a35.39,35.39,0,0,1-28-5",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8,224.7l10.29,59.64A19.19,19.19,0,0,0,132.38,300h0a19.2,19.2,0,0,0,15.74-20.6c-.47-5.29-.87-9.67-.87-9.67s14.94-3.84,13.65-19c-.63-7.34-3.14-22.35-5.58-35.91a28.38,28.38,0,0,0-30.7-23.21l-1.46.14A28.19,28.19,0,0,0,99.8,224.7Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.13,224.61a2.16,2.16,0,0,1-1.87,2.39,2.07,2.07,0,0,1-2.42-1.73,2.16,2.16,0,0,1,1.87-2.39A2.07,2.07,0,0,1,152.13,224.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.79,222.54c-.24.3-2-.75-4.33-.52s-3.93,1.57-4.21,1.31c-.13-.12.09-.65.78-1.27a5.94,5.94,0,0,1,3.34-1.39,5.76,5.76,0,0,1,3.48.76C152.62,221.91,152.91,222.4,152.79,222.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.33,227.28a2.18,2.18,0,0,1-1.88,2.38,2.08,2.08,0,0,1-2.42-1.73,2.18,2.18,0,0,1,1.87-2.39A2.09,2.09,0,0,1,129.33,227.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.92,225.2c-.24.31-2-.74-4.33-.51s-3.92,1.57-4.21,1.31c-.13-.12.09-.65.78-1.27a6,6,0,0,1,3.34-1.39,5.69,5.69,0,0,1,3.48.76C129.75,224.58,130,225.07,129.92,225.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.07,241.67c0-.14,1.4-.53,3.71-1.06.59-.12,1.15-.29,1.21-.71a3.14,3.14,0,0,0-.57-1.72l-2.21-4.36c-3.07-6.22-5.35-11.35-5.1-11.47s2.94,4.82,6,11l2.13,4.4a3.43,3.43,0,0,1,.53,2.3,1.49,1.49,0,0,1-.89,1,4.48,4.48,0,0,1-1,.24A15.77,15.77,0,0,1,140.07,241.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.63,216c-.17.66-2.52.58-5.22,1.18s-4.85,1.56-5.26,1c-.19-.25.13-.89,1-1.59a9,9,0,0,1,3.8-1.76,8.88,8.88,0,0,1,4.19.09C129.15,215.25,129.7,215.7,129.63,216Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.28,215.87c-.36.57-2,.18-4,.34s-3.53.71-4,.19c-.19-.25,0-.81.68-1.38a5.51,5.51,0,0,1,3.13-1.18,5.45,5.45,0,0,1,3.25.76C151.15,215.08,151.43,215.6,151.28,215.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.64,206.46l-.08.08a12,12,0,0,0-3.68,8.14c0,.11,0,.22,0,.31-.17,4.39.36,8.78.15,13.16s-1.28,8.92-4.19,12.21c-1.19,1.35-3.43,2.42-4.65,1.09a3.71,3.71,0,0,1-.74-1.93c-1.82-10.36-5.58-19.35-6.62-30.28a9.21,9.21,0,0,1,3.09-7.86c2.12-1.87,4.75-3.84,7.41-2.88s6.41,5.39,8.58,7.21",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.58,231.06c-.27-.08-10.72-2.06-9.38,8.27s11.44,6.86,11.42,6.56S105.58,231.06,105.58,231.06Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,242.39s-.16.15-.45.32a1.77,1.77,0,0,1-1.34.21c-1.14-.26-2.29-1.88-2.58-3.73a6,6,0,0,1,.17-2.65,2.12,2.12,0,0,1,1.18-1.56.93.93,0,0,1,1.12.36c.18.27.14.49.2.5s.2-.2.06-.62a1.17,1.17,0,0,0-.49-.6,1.38,1.38,0,0,0-1-.13,2.57,2.57,0,0,0-1.68,1.85,6.29,6.29,0,0,0-.25,3c.34,2.07,1.66,3.88,3.21,4.12a1.91,1.91,0,0,0,1.61-.49C104,242.64,104,242.4,104,242.39Z",
    style: {
      fill: "#7c5142"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.12,200.14c-3-3.9,3.46-10.54,8.42-12.65s11.95-.28,17.21.91c3.31.76,6.66,1.93,10,1.46a23,23,0,0,0,6.41-2.31,16.83,16.83,0,0,1,6.5-2,6.28,6.28,0,0,1,5.8,2.93c1.06,2,.11,5-2.11,5.55a5.12,5.12,0,1,1,2.28,9.3c1.37-1.26,3.81.37,3.81,2.22s-1.55,3.37-3.17,4.28c-4.14,2.32-9.24,2.2-13.86,1.13s-9-3-13.6-4.2-12.31-3.36-16.61-1.35c-3.16,1.47-5.06,5.64-7,5a6.35,6.35,0,0,1-3.73-4.34,18.36,18.36,0,0,1-.38-5.92",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.71,232.83a90.41,90.41,0,0,0,1.88,16.34A30.55,30.55,0,0,0,115,263.62c5,5.13,11.56,10,18.66,11.21,7.75,1.28,17.23-.34,23.54-5,3-2.21,5.17-7,4.24-10.62a7.88,7.88,0,0,0,4.5-6.6c.16-2.8-1.55-6.3-3.76-6.67,1.66-.28,2.14-2.92,1.51-4.41s-2.82-1.94-4.48-1.62a11.56,11.56,0,0,0-4.47,2.3,15.77,15.77,0,0,1-4.33,2.58c-5.36,1.74-10.79-3-16.42-2.77-5.09.2-9.62,4.43-14.67,3.72a10.17,10.17,0,0,1-6.8-4.73c-1.56-2.39-.88-11.22-1.49-14",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.56,256.64a9.55,9.55,0,0,1-1.24-.38,6.64,6.64,0,0,0-5.78,1.05c-.64.46-1,.83-1,.78s.2-.49.81-1a6,6,0,0,1,6.11-1.1C146.2,256.24,146.59,256.59,146.56,256.64Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M135.61,245.15c.38-.06.63,2.47,3,4s5,1.05,5.06,1.4c.05.15-.55.55-1.69.69a6.31,6.31,0,0,1-4.21-1,5.49,5.49,0,0,1-2.32-3.42C135.22,245.8,135.44,245.15,135.61,245.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.09,273.14a2.68,2.68,0,0,1,.65.24c.43.16,1.06.38,1.89.61a33.71,33.71,0,0,0,7.2,1.13,31.76,31.76,0,0,0,5-.1,28,28,0,0,0,5.65-1.1,23,23,0,0,0,5.76-2.63,17.48,17.48,0,0,0,5-4.54,10.39,10.39,0,0,0,2-7.5l0-.21.18-.08a8.11,8.11,0,0,0,3.13-2.57,9.13,9.13,0,0,0,1-1.68,6.07,6.07,0,0,0,.44-1.81,7.13,7.13,0,0,0-2.4-6.05l-.15-.12.12-.15a4.2,4.2,0,0,0,.62-4.11,4,4,0,0,0-2.3-2.26,4.4,4.4,0,0,0-2.09-.29c-.49.06-.73.15-.74.12a2.53,2.53,0,0,1,.73-.22,4.36,4.36,0,0,1,4.68,2.53,4.56,4.56,0,0,1-.6,4.47l0-.27a7.55,7.55,0,0,1,2.62,6.39,6.59,6.59,0,0,1-.47,2,10.39,10.39,0,0,1-1.05,1.78,8.48,8.48,0,0,1-3.32,2.75l.15-.3a10.75,10.75,0,0,1-2,7.92,17.94,17.94,0,0,1-5.15,4.67,22.51,22.51,0,0,1-5.89,2.65,27.58,27.58,0,0,1-5.75,1.08,32.23,32.23,0,0,1-5.09,0,31.53,31.53,0,0,1-7.23-1.31,16.28,16.28,0,0,1-1.87-.71A3.7,3.7,0,0,1,128.09,273.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.76,246.75a1.58,1.58,0,0,1-.53-.26,3,3,0,0,1-1-1.32,4.49,4.49,0,0,1-.21-2.66,5.37,5.37,0,0,1,2-2.93,13.36,13.36,0,0,1,3.8-2,24.63,24.63,0,0,0,4.42-1.88,8.64,8.64,0,0,0,3.33-3.92,14.33,14.33,0,0,0,1.18-5.5c.08-3.91-.82-7.62-.92-11.07s.5-6.67,2.07-8.83a8.32,8.32,0,0,1,5-3.43,5.66,5.66,0,0,1,1.68-.08,4.1,4.1,0,0,1,.58.11,8.93,8.93,0,0,0-2.21.17,8.27,8.27,0,0,0-4.79,3.44c-1.46,2.1-2.07,5.22-1.89,8.6s1,7.09,1,11.11A14.84,14.84,0,0,1,95,232a9.09,9.09,0,0,1-3.55,4.12A23.64,23.64,0,0,1,86.9,238a13.15,13.15,0,0,0-3.71,1.86,5.06,5.06,0,0,0-1.93,2.7,4.27,4.27,0,0,0,.11,2.52A3.33,3.33,0,0,0,82.76,246.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.73,193.86a2.28,2.28,0,0,1,.45-.21,3.35,3.35,0,0,1,.59-.2,5,5,0,0,1,.83-.17,6.19,6.19,0,0,1,5.1,1.83h0a8.29,8.29,0,0,1,1.55,6.2,10.17,10.17,0,0,1-4.1,6.77,15.71,15.71,0,0,1-8.7,3A34.88,34.88,0,0,1,143.36,210a45.76,45.76,0,0,1-14.66-6.49,46.07,46.07,0,0,0-6-3.49,16.4,16.4,0,0,0-5.8-1.48,17.32,17.32,0,0,0-8.51,1.58c-1.87.88-2.76,1.64-2.8,1.58a12.28,12.28,0,0,1,2.71-1.77,17.25,17.25,0,0,1,8.62-1.76,16.7,16.7,0,0,1,6,1.45,46.53,46.53,0,0,1,6.09,3.49,46.09,46.09,0,0,0,14.52,6.38,34.74,34.74,0,0,0,9.94,1.12,15.43,15.43,0,0,0,8.45-2.88,9.86,9.86,0,0,0,4-6.46,8,8,0,0,0-1.39-6h0a6.09,6.09,0,0,0-4.85-1.87A13,13,0,0,0,157.73,193.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.43,185.05a5.85,5.85,0,0,1-.47,2.29,9.75,9.75,0,0,1-4.28,4.67,12.26,12.26,0,0,1-4.17,1.5,17.61,17.61,0,0,1-5.08,0c-3.57-.45-7.26-1.85-11.14-3.06s-7.79-1.93-11.23-1.19a14.84,14.84,0,0,0-7.89,4.6,15.41,15.41,0,0,0-3.19,5.36c-.46,1.42-.55,2.25-.61,2.24a2.46,2.46,0,0,1,0-.6,11.45,11.45,0,0,1,.37-1.7,14.77,14.77,0,0,1,3.11-5.55,15,15,0,0,1,8.06-4.82c3.56-.79,7.58-.06,11.48,1.16s7.56,2.62,11.05,3.08a17.13,17.13,0,0,0,4.95,0,12,12,0,0,0,4.06-1.39,9.76,9.76,0,0,0,4.27-4.43A14.25,14.25,0,0,0,152.43,185.05Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.12,121.76c-.09.11-5.71-4.46-12.56-10.21S203.24,101,203.34,100.93s5.71,4.46,12.56,10.22S228.22,121.65,228.12,121.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.64,114.91c-.14,0-.71-8.88-1.26-19.85s-.89-19.87-.75-19.88.71,8.88,1.27,19.86S256.78,114.91,256.64,114.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.48,108.56c-.14,0-1.89-5-3.92-11.33S231,85.79,231.14,85.75s1.89,5,3.92,11.32S238.61,108.52,238.48,108.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.29,131.14a69,69,0,0,1-7.71-3.25,67,67,0,0,1-7.5-3.73,69,69,0,0,1,7.71,3.25A68,68,0,0,1,222.29,131.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,119.65c0,.14-.85.16-1.86,0s-1.81-.34-1.79-.48.85-.16,1.85,0S196,119.51,196,119.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.79,79.29c-.15,0-.26-.81-.26-1.82s.11-1.83.26-1.83.26.82.26,1.83S231.93,79.29,231.79,79.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,93.41c.11.1-4.51,5.39-10.3,11.82S271.13,116.8,271,116.7s4.51-5.38,10.3-11.82S291.9,93.32,292,93.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.35,86.14c.1.1-.43.8-1.19,1.56s-1.45,1.28-1.55,1.18.43-.8,1.19-1.55S299.25,86,299.35,86.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.17,111.74a9.12,9.12,0,0,1-1.36.81c-.89.49-2.19,1.18-3.81,2-3.25,1.64-7.8,3.78-12.92,5.91s-9.85,3.83-13.31,5c-1.72.57-3.12,1-4.1,1.29a8,8,0,0,1-1.53.39,9.46,9.46,0,0,1,1.47-.58l4-1.45c3.42-1.23,8.11-3,13.23-5.1s9.67-4.21,13-5.76l3.88-1.84A10.8,10.8,0,0,1,317.17,111.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.55,136.36a13.62,13.62,0,0,1-2.66.87c-1.66.46-4,1-6.58,1.45s-5,.7-6.69.82a12.86,12.86,0,0,1-2.79.05,18.51,18.51,0,0,1,2.76-.42c1.7-.21,4.05-.53,6.63-1s4.91-.92,6.59-1.28A15.1,15.1,0,0,1,302.55,136.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.84,133.9a16.08,16.08,0,0,1-5.76,0,16.08,16.08,0,0,1,5.76,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.68,382a10.65,10.65,0,0,1,7,4.48,18.73,18.73,0,0,1,3,7.93c.91,5.44-.56,11.62-2.58,16.76-5.55-2.61-8.51-9.07-9.8-12.45-2-5.33-2.51-16.22,2.33-16.72",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.33,418.86a9.05,9.05,0,0,1-.21-9.1,12,12,0,0,1,7.38-5.66,5.08,5.08,0,0,1,4.27.3,3.88,3.88,0,0,1,1.4,3.67,7.92,7.92,0,0,1-1.74,3.69c-2.9,3.74-6.38,6.82-11.1,7.1",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.93,436.1a4.2,4.2,0,0,1-.19-1.14c-.07-.74-.17-1.82-.24-3.15a39.29,39.29,0,0,1,.63-10.4,19.71,19.71,0,0,1,4.73-9.27,12.76,12.76,0,0,1,2.46-2,3.26,3.26,0,0,1,1-.52,25.56,25.56,0,0,0-3.18,2.83,20.48,20.48,0,0,0-4.44,9.1,44.57,44.57,0,0,0-.8,10.26A35.64,35.64,0,0,1,254.93,436.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,390.29a12,12,0,0,1,.7,1.78c.41,1.16,1,2.84,1.66,4.93,1.37,4.18,3.16,10,5,16.45s3.32,12.35,4.34,16.63c.51,2.14.9,3.87,1.15,5.08a11.24,11.24,0,0,1,.34,1.88,10.58,10.58,0,0,1-.57-1.82c-.35-1.3-.8-3-1.34-5-1.13-4.25-2.7-10.12-4.52-16.57s-3.54-12.28-4.8-16.49l-1.47-5A11.64,11.64,0,0,1,242,390.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.94,424A21.22,21.22,0,0,0,233.78,412c-1.68-.32-3.75-.28-4.69,1.16s-.13,3.36.88,4.74a18.11,18.11,0,0,0,19,6.64",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.62,416.79a3.84,3.84,0,0,1,1.11.12,8.87,8.87,0,0,1,1.27.27,15.38,15.38,0,0,1,1.66.49,22.38,22.38,0,0,1,4.08,1.91,23.56,23.56,0,0,1,7.88,7.63,22.24,22.24,0,0,1,2,4,14.35,14.35,0,0,1,.55,1.64,8.72,8.72,0,0,1,.32,1.27,3.48,3.48,0,0,1,.14,1.1c-.11,0-.42-1.53-1.41-3.84a25,25,0,0,0-2.11-3.87,27.13,27.13,0,0,0-3.45-4.14,27.58,27.58,0,0,0-4.24-3.32,25.43,25.43,0,0,0-3.94-2C237.16,417.17,235.6,416.91,235.62,416.79Z",
    style: {
      fill: "#263238"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHighFivePana, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/High-five-pana.b8faf779.svg";
export { ForwardRef as ReactComponent };